import Head from "next/head";
import React, { useContext, useEffect, useRef, useState } from "react";
import { useRouter } from "next/router";
import Footer from "../../components/Footer";
import Navigation from "../../components/Navigation";

import WordpressApi, { FaqCategory, Menus } from "../../services/wordpressApi";
import ComposerBlocks from "../../components/ComposerBlocks";
import Seo from "../../components/Seo/Seo";
import Breadcrumbs from "../../components/Breadcrumbs/Breadcrumbs";
import { IBreadcrumb } from "../../services/breadcrumbReducer";
import { Collapse, Container, OverlayTrigger, Tooltip } from "react-bootstrap";
import styles from "./faq.module.css";
import Link from "next/link";
import LinkButton from "../../components/elements/LinkButton";
import { Img } from "../../components/elements/Img";
import { isMobile } from "react-device-detect";
import { FadeIn } from "../../components/FadeIn";
import { Link as ScrollLink } from "react-scroll";
import LanguageContext, { Languages } from "../../components/LanguageContext";

const translations = {
  [Languages.English]: {
    selectCategory: "Select a question category:",
    selectSubcategory: "Select a question subcategory:",
    prev: "Previous",
    prevQuestion: "Previous question",
    next: "Next",
    nextQuestion: "Next question",
    copied: "Link copied",
  },
  [Languages.German]: {
    selectCategory: "Wählen Sie eine Fragekategorie aus:",
    selectSubcategory: "Wählen Sie eine Unterkategorie für Fragen aus:",
    prev: "Vorherige",
    prevQuestion: "Vorherige Frage",
    next: "Nächste",
    nextQuestion: "Nächste Frage",
    copied: "Link kopiert",
  },
};
interface SingleCategory {
  id: number;
  parent: number;
  name: string;
  slug: string;
}

export default function Composer({
  data,
  menus,
  tags,
  breadcrumbs,
  header,
  faqCategory,
  faqList,
  htmlHead,
}: {
  data: any;
  menus: Menus;
  tags: any;
  breadcrumbs: IBreadcrumb[];
  header: string;
  faqCategory: FaqCategory[];
  faqList: {
    blocks: any[];
    title: { rendered: string };
    slug: string;
  }[];
  htmlHead: string;
}) {
  const router = useRouter();
  const { language } = useContext(LanguageContext);
  const [activeLink, setActiveLink] = useState(0);
  const [activeSlug, setActiveSlug] = useState("");
  const [showTooltip, setShowTooltip] = useState(false);
  const [isCategoriesOpen, setIsCategoriesOpen] = useState(true);
  const [separatedCategories, setSeparatedCategories] = useState<
    SingleCategory[]
  >([]);
  const [separatedSubcategories, setSeparatedSubcategories] = useState<
    SingleCategory[]
  >([]);
  console.log(language);

  const timer = useRef<NodeJS.Timeout | null>(null);
  const nextPrevButtonHandler = (click: string) => {
    click === "next"
      ? activeLink === faqList.length - 1
        ? null
        : setActiveLink(activeLink + 1)
      : activeLink === 0
      ? null
      : setActiveLink(activeLink - 1);
  };

  const copyLink = (event: React.MouseEvent<HTMLElement>) => {
    event.preventDefault();
    navigator.clipboard.writeText(
      `${window.location.host}/faq?pytanie=${activeSlug}`
    );
    setShowTooltip(true);
    timer.current = setTimeout(() => {
      setShowTooltip(false);
    }, 1500);
  };

  const renderTooltip = (props: any) => {
    return (
      <Tooltip
        className={styles.copyTooltip}
        placement="bottom"
        key="bottom"
        {...props}
      >
        {translations[language].copied}
      </Tooltip>
    );
  };

  const renderNothing = (props: any) => {
    return <div />;
  };

  useEffect(() => {
    if (typeof activeLink === "number") {
      const actualFaq = faqList.find((el, index) => index == activeLink);
      if (actualFaq?.slug) {
        setActiveSlug(actualFaq.slug);
      }
    }
  }, [activeLink]);

  useEffect(() => {
    return () => {
      if (timer.current !== null) {
        clearTimeout(timer.current);
      }
    };
  }, []);

  useEffect(() => {
    if (!faqCategory) return;

    faqCategory.forEach((elem) => {
      if (elem.parent === 0) {
        setSeparatedCategories((prevState) => [...prevState, elem]);
        return;
      }

      setSeparatedSubcategories((prevState) => [...prevState, elem]);
    });
  }, []);
  return (
    <div>
      <Seo header={htmlHead} />
      <Head>
        <meta
          name="viewport"
          content="width=device-width, initial-scale=1.0, maximum-scale=2.0, minimal-scale=1.0"
        />
      </Head>
      <Navigation menu={menus.primary} />
      <main id="bootstrap-overrides">
        {breadcrumbs && (
          <Breadcrumbs breadcrumbs={breadcrumbs} header={header} />
        )}
        <ComposerBlocks data={data} />
        <Container className={styles.container}>
          <div
            aria-controls="categories-selector-collapse"
            aria-expanded={isCategoriesOpen}
            className={styles.categoryTitleContainer}
            onClick={() => setIsCategoriesOpen(!isCategoriesOpen)}
          >
            <h5 className={styles.categoryTitle}>
              {translations[language].selectCategory}
            </h5>
            <div className={styles.arrow}></div>
          </div>
          <Collapse in={isCategoriesOpen}>
            <div
              className={styles.filtersContainer}
              id="categories-selector-collapse"
            >
              {separatedCategories.map(({ name, slug }) => (
                <Link
                  href={`  ${
                    language === "en"
                      ? "/en/lcl-faq-german-language-school/"
                      : "/sprachschule-faq-deutschsprachkursesprachpruefungen/"
                  }${slug}`}
                >
                  <div
                    onClick={() => setActiveLink(0)}
                    key={`categories-faq-${slug}`}
                    className={`${
                      router.asPath ==
                      `  ${
                        language === "en"
                          ? "/en/lcl-faq-german-language-school/"
                          : "/sprachschule-faq-deutschsprachkursesprachpruefungen/"
                      }${slug}`
                        ? styles.offerButtonActive
                        : styles.offerButton
                    }`}
                  >
                    {name}
                  </div>
                </Link>
              ))}
            </div>
          </Collapse>
        </Container>
        <Container className={styles.subContainer}>
          <div
            aria-controls="categories-selector-collapse"
            aria-expanded={isCategoriesOpen}
            className={styles.categoryTitleContainer}
            onClick={() => setIsCategoriesOpen(!isCategoriesOpen)}
          >
            <h5 className={styles.categoryTitle}>
              {translations[language].selectSubcategory}
            </h5>
            <div className={styles.arrow}></div>
          </div>
          <Collapse in={isCategoriesOpen}>
            <div
              className={styles.filtersContainer}
              id="categories-selector-collapse"
            >
              {separatedSubcategories.map(({ name, slug }) => (
                <Link
                  href={`  ${
                    language === "en"
                      ? "/en/lcl-faq-german-language-school/"
                      : "/sprachschule-faq-deutschsprachkursesprachpruefungen/"
                  }${slug}`}
                >
                  <div
                    onClick={() => setActiveLink(0)}
                    key={`categories-faq-${slug}`}
                    className={`${
                      router.asPath ==
                      `  ${
                        language === "en"
                          ? "/en/lcl-faq-german-language-school/"
                          : "/sprachschule-faq-deutschsprachkursesprachpruefungen/"
                      }${slug}`
                        ? styles.offerButtonActive
                        : styles.offerButton
                    }`}
                  >
                    {name}
                  </div>
                </Link>
              ))}
            </div>
          </Collapse>
        </Container>
        <Container fluid className={styles.mainFaqContainer}>
          <Container className={styles.faqWrapper}>
            <div className={styles.leftFaqSide}>
              {faqList.map(({ title }, index) => (
                <>
                  <ScrollLink
                    to="pytanie"
                    smooth={true}
                    offset={-40}
                    duration={500}
                  >
                    <h5
                      onClick={() => {
                        setActiveLink(index);
                      }}
                      className={`${
                        index === activeLink
                          ? styles.linkList
                          : styles.linkListActive
                      }`}
                    >
                      {title.rendered}
                    </h5>
                  </ScrollLink>
                </>
              ))}
            </div>
            <div className={styles.rightFaqSide} id="pytanie">
              {faqList
                .filter((el, index) => index == activeLink)
                .map(({ title, blocks }) => (
                  <div className={styles.faqContent}>
                    <FadeIn>
                      <h5 className={styles.faqSingleTitle}>
                        {title.rendered}
                      </h5>
                    </FadeIn>
                    <ComposerBlocks data={blocks} />
                  </div>
                ))}
              <div className={styles.NextPrevWrapper}>
                <div>
                  <ScrollLink
                    to="pytanie"
                    smooth={true}
                    offset={-40}
                    duration={500}
                  >
                    <div
                      onClick={() => nextPrevButtonHandler("prev")}
                      className={
                        activeLink === 0 ? styles.iconFaded : styles.iconActive
                      }
                    >
                      <LinkButton arrowReverted variant="primary">
                        {isMobile
                          ? translations[language].prev
                          : translations[language].prevQuestion}
                      </LinkButton>
                    </div>
                  </ScrollLink>
                </div>
                <OverlayTrigger
                  placement="bottom"
                  overlay={showTooltip ? renderTooltip : renderNothing}
                >
                  <div onClick={copyLink} className={styles.iconActive}>
                    <Img className={styles.iconHover} />
                  </div>
                </OverlayTrigger>
                <ScrollLink
                  to="pytanie"
                  smooth={true}
                  offset={-40}
                  duration={500}
                >
                  <div
                    onClick={() => nextPrevButtonHandler("next")}
                    className={
                      activeLink === faqList.length - 1
                        ? styles.iconFaded
                        : styles.iconActive
                    }
                  >
                    <LinkButton variant="primary">
                      {isMobile
                        ? translations[language].next
                        : translations[language].nextQuestion}
                    </LinkButton>
                  </div>
                </ScrollLink>
              </div>
            </div>
          </Container>
        </Container>
      </main>
      <Footer {...menus} />
    </div>
  );
}
interface IProps {
  query: Record<string, string>;
}

export async function getServerSideProps({ query }: IProps) {
  let data: any;
  let menus = {};
  let faqList = [];
  let faqCategory = [];
  let htmlHeader = "";
  try {
    [data, menus, faqCategory, faqList] = await Promise.all([
      WordpressApi.getPage(
        "sprachschule-faq-deutschsprachkursesprachpruefungen"
      ),
      WordpressApi.getMenus(),
      WordpressApi.getFAQCategory(),
      WordpressApi.getSingleFAQ(query?.pytanie ? query.pytanie : ""),
    ]);
  } catch (error) {
    console.log(error);
    return {
      notFound: true,
    };
  }

  return {
    props: {
      data: data && data.blocks ? data.blocks : [],
      tags: data && data.tags ? data.tags : [],
      breadcrumbs: data && data.breadcrumbs ? data.breadcrumbs : [],
      header: data?.header || "",
      htmlHead: data && data.htmlHead ? data.htmlHead : "",
      menus,
      faqCategory,
      faqList,
    },
  };
}
